import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useAccountId = () => {
  const query = useQuery({
    queryKey: [QueryKeys.ACCOUNT_ID],
    queryFn: () => accountRepo.getAccountId(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseAccountId = ReturnType<typeof useAccountId>;
